export const schema = {
    orgId: "https://schemas.saysimple.io/orgId",
    roles: "https://schemas.saysimple.io/roles",
    apiKey: "https://schemas.saysimple.io/apiKey",
    userId: "https://schemas.saysimple.io/userId",
    customerId: "https://schemas.saysimple.io/customerId",
};
